import React, {useMemo, useState} from 'react';
import {withFormsy,validationRules} from 'formsy-react';
import {validationFor} from "./Form";

const InputOption = ({option, index, currentInputs, shouldValidate = true,...props}) => {

    const [isPristine, setIsPristine] = useState(true);
    const [errorMessage, setErrorMessage] = useState(undefined);
    let {
        label,
        ...inputOptions
    } = option;

    let validation = validationFor(option);


    const validateInput = (value) => {
        let validationErrors = [];
        TB.map(validation.rules, (validateRule, rule)=> {
            if (!validationRules[rule](currentInputs,value, validateRule)) {
                validationErrors.push(validation.errors[rule]);
            }
        });
        if (validationErrors.length) {
            return validationErrors.join('\n');
        }
        return false;
    }


    return (
       <div className={TB.mapClass("form-group mb-2", {"text-danger": shouldValidate && errorMessage})}>
           <div key={option.name} className="input-group">
               <input
                   {...inputOptions}
                   className={TB.mapClass("form-control", {
                       'is-invalid': shouldValidate && errorMessage
                   })}
                   onBlur={() => {
                       if (!isPristine) {
                           setErrorMessage(validateInput(option.value))
                       }
                   }}
                   onChange={e => {
                       e.preventDefault();

                       let value = e.currentTarget.value;

                       props.setValue(value);
                       setIsPristine(false)
                   }}
               />
               {index > 0 && (
                   <span className="clickable p-2" onClick={props.onRemove}>
                       <i className="fa fa-times text-muted"/>
                   </span>
               )}

           </div>
           {shouldValidate && errorMessage && (
               <span className="invalid-feedback">
                   {errorMessage}
               </span>
           )}
       </div>

    )
}

const MultiInput = ({maxInputs = 5,inputProps = {type: 'text'}, ...props}) => {


    let currentInputs = props.getValue() || [];

    const inputOptions = useMemo(() => {
        let options = [];
        for (let inputIndex = 0;inputIndex < (currentInputs.length || 1); inputIndex++) {
            let option = {
                ...inputProps,
                value: currentInputs[inputIndex] || '',
                name: `${props.name}[${inputIndex}]`,
                disabled: props.disabled,
            }
            options.push(option)

        }
        return options;
    }, [currentInputs]);

    const errorMessage = props.getErrorMessage();
    let className = props.showRequired() ? 'required ' : '';

    className += !props.isValid() && props.isFormSubmitted() ? 'text-danger' : '';
    let inputClassName = !props.isValid() && props.isFormSubmitted() ? 'is-invalid' : '';

    let validation = validationFor(inputProps);

    const isLastValid = useMemo(() => {
        let value = TB.last(currentInputs) || '';

        if (!value.length) return false;

        let valid = true;
        TB.map(validation.rules, (validateRule, rule)=> {
            if (!validationRules[rule](currentInputs,value, validateRule)) {
                valid = false
            }
        })
        return valid
    },[TB.last(currentInputs)])


    return (
        <div className={"multi-input-group form-group mb-0 " + className}>

            <div className="flex flex-col items-stretch">
                {props.label && (
                    <label className="col-form-label" data-required={props.required}>
                        {props.label}
                        {props.required && <span className="required-symbol"> *</span>}
                    </label>
                )}

                <div className="flex flex-col multi-input-container">
                    {TB.map(inputOptions, (option, index) => {
                        // let inputClass = "form-control ";
                        //
                        // if (props.validateInput) {
                        //     let isValid = props.validateInput(option.value);
                        // }

                        return (
                            <InputOption
                                setValue={value => {
                                    let changeInputs = [...currentInputs];
                                    changeInputs[index] = value;
                                    props.setValue(changeInputs)
                                }}
                                onRemove={() => {
                                    let changeInputs = [...currentInputs];
                                    changeInputs.splice(index, 1);
                                    props.setValue(changeInputs)
                                }}
                                key={option.name} option={option} index={index} currentInputs={currentInputs}/>
                        )
                    })}
                </div>


                {currentInputs.length < maxInputs && isLastValid && (
                    <div className="add-more-input mt-1">
                        <button type="button" className="btn btn-link btn-link-info" onClick={() => props.setValue([...currentInputs, ''])}>
                            {props.addMoreText || 'Add another'}
                        </button>
                    </div>
                )}

            </div>
            {errorMessage && (
                <span className="invalid-feedback">
                    {errorMessage}
                </span>
            )}
        </div>
    )
};


const MultiInputGroup = withFormsy(MultiInput);
export default MultiInputGroup;